<template>
  <b-card>
    <div slot="header">
      <h4 class="mr-5 pull-left">{{$t('CLIENTS')}}</h4>
      <new-button button_type="new" variant="primary" class="pull-right"  @click="aside = true">
        Novi klijent
      </new-button>
    </div>
    <app-aside :widths="['col-sm-12', '40%']" v-model="aside">
      <template slot="header">Novi klijent</template>
      <b-form-radio-group
        id="radio-group-2"
        v-model="selected"
        name="radio-sub-component"
      >
        <b-form-radio :value="PHYSICAl_PERSON">Fizičko lice</b-form-radio>
        <b-form-radio :value="LEGAL_ENTITY">Pravno lice</b-form-radio>
      </b-form-radio-group>
      <br/>
      <ClientLegalEntityForm v-if="selected === LEGAL_ENTITY" @success="closePanel"/>
      <ClientForm v-if="selected === PHYSICAl_PERSON" @success="closePanel"/>
    </app-aside>
    <app-aside :widths="['col-sm-12', '40%']" v-model="editAside">
      <template slot="header">Uredi klijenta</template>
      <template v-if="editClientObject">
        <ClientLegalEntityForm :client-id="editClientObject.id" v-if="editClientObject.type === LEGAL_ENTITY" @success="closePanel"/>
        <ClientForm :client-id="editClientObject.id"  v-if="editClientObject.type === PHYSICAl_PERSON" @success="closePanel"/>
      </template>
    </app-aside>
    <div class="position-relative">
      <form class="mb-4" @submit.prevent="search" @reset.prevent="resetForm">
        <b-row>
          <b-col md="3" class="">
            <label class="label-text">Ime i prezime / Naziv firme</label>
            <b-input  v-model="filter.name" type="text"></b-input>
          </b-col>

          <b-col md="2" class="">
            <label class="label-text">{{$t('TYPE')}}</label>
            <b-select :options="type_options"
                      type="select"
                      v-model="filter.type">
            </b-select>
          </b-col>
          <b-col md="2" class="">
            <label class="label-text">Mjesto</label>
            <b-input  v-model="filter.place" type="text"></b-input>
          </b-col>
          <b-col md="2" class="">
            <label class="label-text">Država</label>
            <b-input  v-model="filter.country" type="text"></b-input>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="d-inline-flex">
            <app-submit :disabled="loading" :loading="loader_submit" class="mr-3" variant="primary"  button_type="search"> {{$t('SEARCH')}}</app-submit>
            <app-submit :disabled="loading" :loading="loader_reset" class="mr-3" variant="outline-primary" type="reset" button_type="reset">{{$t('RESET')}}</app-submit>
          </b-col>
        </b-row>
      </form>
      <div class="table-container">
        <b-table class="applicant_table animated fadeIn"  responsive hover  :fields="fields" :items="items" primary-key="id" :busy="loading">
          <template v-slot:cell(type) = "data">
            {{data.item.type === 1 ?  $t('LEGAL_ENTITY') : data.item.type === 2 ?  $t('PHYSICAl_PERSON') : ''}}
          </template>
          <template v-slot:cell(edit)="data">
            <app-button class="pull-right" @click="edit(data.item)"
                        size="sm"
                        variant="link">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </app-button>
          </template>
        </b-table>
        <b-pagination
          size="sm"
          :prev-text="$t('PREV')"
          :next-text="$t('NEXT')"
          :total-rows="total"
          :per-page="perPage"
          v-model="currentPage">
        </b-pagination>

      </div>
    </div>
  </b-card>
</template>

<script>
import AppAside from '@/components/app/form/AppAside'
import NewButton from '@/components/app/AppButton'
import AppButton from "@/components/app/AppButton";
import {getClientList} from "@/services/client";
import routeNames from '@/router/routeNames'
import ClientForm from "@/components/client/ClientForm";
import ClientLegalEntityForm from "@/components/client/ClientLegalEntityForm";
import AppSubmit from "@/components/app/AppSubmit";
export default {
  name: "index",
  data(){
    return {
      fields: [
        {key: 'name', label: 'Ime i prezime / Naziv firme'},
        {key: 'type', label: this.$t('TYPE')},
        {key: 'email', label: this.$t('EMAIL')},
        {key: 'place', label: this.$t('PLACE')},
        {key: 'country', label: this.$t('COUNTRY')},
        {key: 'edit', label: ''},
      ],
      editAsidePanelState: false,
      currentPage: 1,
      listCount: 100,
      perPage: 20,
      total: 0,
      loading: false,
      routeNames,
      aside: false,
      LEGAL_ENTITY: 1,
      PHYSICAl_PERSON: 2,
      selected: 2,
      loader_submit: false,
      loader_reset: false,
      filter: {
        name: null,
        type: null,
        country: null,
        place: null
      },
      type_options: [
        {value: null, text: '-'},
        { value: 1, text: 'Pravno lice' },
        { value: 2, text: 'Fizičko lice' },
      ],
      editClientObject: null,
      editAside: false,
      items:[],
    }
  },
  components:{
    AppSubmit,
    NewButton,
    AppAside,
    AppButton,
    ClientForm,
    ClientLegalEntityForm
  },
  methods: {
    closePanel() {
      this.aside = false;
      this.editAside = false;
      this.search();
    },

    resetForm() {
      this.filter = {
        name: null,
        type: null,
        country: null,
        place: null
      }
      this.search();
    },
    search() {
      this.loading = true;
      const request = {...this.filter, ...{ limit: 20, page: this.currentPage }}
       getClientList(request).then((response) => {
        this.items = response.data.items
        this.total = response.data.total
        this.currentPage = response.data.page
      }).finally(() => {
        this.loading = false
       })
    },
    edit(client) {
      this.editAside = true;
      this.editClientObject = client;
    }
  },
  async mounted(){
    await this.search();
  },
  watch: {
    currentPage: {
      handler() {
        this.search();
      }
    }
  }
}
</script>

<style scoped>

</style>
